import { Controller } from "@hotwired/stimulus"

// Removes the element and remembers the choice in a cookie, so the server
// stops rendering it until the cookie expires.
export default class extends Controller {
  static values = {
    cookie: String,
    maxAge: { type: Number, default: 3600 } // seconds
  }

  dismiss() {
    document.cookie = `${this.cookieValue}=1; path=/; max-age=${this.maxAgeValue}; SameSite=Lax`
    this.element.remove()
  }
}
